export default __webpack_public_path__ + "5707ffa.png";